export default __webpack_public_path__ + "static/media/main-banner-m-3.d2e775c5.svg";